import { useEffect } from "react";

/**
 * Gaming-styled coming-soon modal for footer / site links
 * that do not have a live page yet.
 */
const GamingPopup = ({ open, title, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="gaming-popup"
      role="dialog"
      aria-modal="true"
      aria-labelledby="gaming-popup-title"
      onClick={onClose}
    >
      <div
        className="gaming-popup__panel"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="gaming-popup__close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <p className="gaming-popup__brand">ATHERIAM</p>
        <h2 id="gaming-popup-title" className="gaming-popup__title">
          {title || "This feature"}{" "}
          <span>Coming Soon</span>
        </h2>
        <p className="gaming-popup__copy">
          We are building this into the Atheriam gaming ecosystem. Check back
          soon - powered by $ATH.
        </p>
        <button
          type="button"
          className="gaming-popup__cta"
          onClick={onClose}
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default GamingPopup;
